import { CommitmentReminderActionTypeEnum } from 'legacy/lut/services/partner360/commitment/models/ICommitmentReminder'

import {
  FinancialCockpitPendingActionOwner,
  FinancialCockpitPendingActionPriority,
  type IFinancialCockpitPendingAction,
} from '../../../../api/types'
import { FINANCIAL_COCKPIT_NAMESPACE } from '../../../../configs/translations'

/* Keys this section needs and `configs/translations.ts` does not carry yet. Declared here in the
   feature's own namespace so the section reads the same once they are moved into the registry. */
export const SOB_KEYS = {
  /** The row's second line where nothing has come in for the category at all. */
  rowMissing: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-sob-row-missing`,
  /** The same, for a category answered in some quarters but not the one being collected. */
  rowPartial: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-sob-row-partial`,
  /** The title of the stand-in action; the row itself leads with the category. */
  update: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-sob-update`,
  /** The way to the FinSOB section, closing the lead sentence. */
  openSection: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-sob-open-section`,
  /** The offering collects SOB on nothing the payload names — the status cannot be broken down. */
  noCategories: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-sob-no-categories`,
  /** Every category the offering collects SOB on already carries a figure for the period. */
  allSubmitted: `${FINANCIAL_COCKPIT_NAMESPACE}-attention-sob-all-submitted`,
}

/**
 * The stand-in for a category the catalog says is owed and no pending action names.
 *
 * `usePendingActionInvocation` opens every one of its dialogs off an action, so a category with no
 * action of its own needs one to be reached at all. Only the fields that hook actually reads are
 * filled: the type chooses the dialog, `ActionParam.Category` scopes it to this category, and the
 * absent `ActionLink` is what keeps `selectAction` on the dialog rather than navigating away.
 *
 * Nothing here is presented to the reader as the server's word — the row states the category and
 * what is missing from the payload, never a pending action the payload does not carry.
 */
export const buildSobEntryAction = (
  category: string,
  owner: FinancialCockpitPendingActionOwner,
  order: number
): IFinancialCockpitPendingAction => ({
  ActionOrder: order,
  ActionSortOrder: order,
  ActionType: CommitmentReminderActionTypeEnum.JbpPatSob,
  ActionCategory: 'sob',
  ActionTitle: SOB_KEYS.update,
  ActionParam: JSON.stringify({ Category: category }),
  ActionPriority: FinancialCockpitPendingActionPriority.High,
  ActionOwner: owner,
  ActionUser: '',
})
